import React from "react";
import { useSeller } from "../../contexts/SellerContext";

const LotSummaryPreview = ({
  formData,
  Lot,
  activeTab,
  lotSizes,
  totals,
  getSizeUnit,
  getSizeInfo,
  openLotDrawer,
}) => {
  const { seller } = useSeller();
  const segment = seller?.segment;
  if (!formData.productName || !getSizeInfo()) return null;

  const segmentUpper = (segment || "").toUpperCase();
  const showPrice = [
    "DECOR",
    "BRAND",
    "TOOL",
    "TOOLS",
    "MACHINE",
  ].includes(segmentUpper);
  const showcaratRate = [
    "GEMS",
    "GEM",
    "PEARL",
    "PEARLS",
  ].includes(segmentUpper);

  const hasSpecCol =
    !showPrice && formData.specification && formData.specification !== "PLANE";

  return (
    <div className="lot-summary" onClick={() => openLotDrawer()}>
      <label>
        {Lot ? "Lot Details" : "Single Details"} ({getSizeUnit()})
        {getSizeInfo()?.note && (
          <span className="size-note"> ({getSizeInfo().note})</span>
        )}
      </label>
      <div className="lot-preview">
        <div className="lot-preview-table">
          <table className="lot-table">
            <thead>
              <tr>
                <th>Size</th>
                {activeTab !== "order" && <th>Sets</th>}
                {showPrice ? (
                  <th>Price</th>
                ) : (
                  <>
                    <th>
                      {activeTab === "order" ? "Gross Wt / Set " : "Gross"}
                      {showcaratRate ? "(Ct.)" : "(gm.)"}
                    </th>
                    <th>
                      {activeTab === "order" ? "Net Wt / Set " : "Net"}
                      {showcaratRate ? "(Ct.)" : "(gm.)"}
                    </th>
                    {hasSpecCol && <th>{formData.specification}</th>}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {lotSizes.map((item, index) => (
                <tr key={index}>
                  <td>{item.size || "-"}</td>
                  {activeTab !== "order" && <td>{item.set || "0"}</td>}
                  {showPrice ? (
                    <td>{item.price || "0.00"}</td>
                  ) : (
                    <>
                      <td>
                        {activeTab === "order"
                          ? item.avgGrossWt || "0.000"
                          : item.grossWt || "0.000"}
                      </td>
                      <td>
                        {activeTab === "order"
                          ? item.avgNetWt || "0.000"
                          : item.netWt || "0.000"}
                      </td>
                      {hasSpecCol && <td>{item.avgSpecWt || "0.000"}</td>}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="totals-row">
                <td>Total ({Lot ? "Lot" : "Single"})</td>
                {activeTab !== "order" && <td>{totals?.totalSets ?? 0}</td>}
                {showPrice ? (
                  <td>{(totals?.totalPrice || 0).toFixed(2)}</td>
                ) : (
                  <>
                    <td>{(totals?.totalGrossWt || 0).toFixed(3)}</td>
                    <td>{(totals?.totalNetWt || 0).toFixed(3)}</td>
                    {hasSpecCol && (
                      <td>{`(${formData.specification}) ${(
                        (totals?.totalGrossWt || 0) - (totals?.totalNetWt || 0)
                      ).toFixed(3)}`}</td>
                    )}
                  </>
                )}
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="click-to-edit">
          Click to {Lot ? "edit lot" : "edit size"} details
        </div>
      </div>
    </div>
  );
};

export default LotSummaryPreview;
